import Cookies from 'js-cookie';

const API = {
	wsURL: 'wss://staging-api.easybids.com/',
	baseURL: process.env.REACT_APP_BASE_URL,
	// baseURL: 'https://staging.easybids.com/api',
	// Configured axios instance (import separately if needed)
	options: {
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json',
			'access-token': Cookies.get('access_token'),
			'uid': Cookies.get('uid'),
			'client': Cookies.get('client'),
			'is_consumer': 'true',
		}
	},
	fileOptions: {
		headers: {
			'Content-Type': 'multipart/form-data',
			'access-token': Cookies.get('access_token'),
			'uid': Cookies.get('uid'),
			'client': Cookies.get('client'),
			'is_consumer': 'true',
		}
	},
	endPoints: {
		"projectsList": "/service-search",
		"projectSubTypes": "/project_sub_types",
		"deleteDocument": "/delete_document",
		"postProjects": "/v2/customers/projects",
		"updateProject": "/projects",
		"postProjectAnswers": "/v2/customers/projects",
		"postProjectLastStep": "/v2/customers/projects",
		"projectDetails": "/v2/customers/projects/",
		"primaryNotifications": "/v2/customers/notifications",

		"allProjects": "/v2/customers/my_projects/all",
		"ongoingProjects": "/v2/customers/my_projects/ongoing",
		"draftProjects": "/v2/customers/my_projects/draft",
		"historyProjects": "/v2/customers/my_projects/history",

		"ProjectDetails": "/v2/customers/projects/",
		"bidDetails": "/v2/customers/projects/",
		"projectChat": "/messages/all/v2?project_id=",
		"confirmHire": "/v2/customers/projects/",
		"requestBid": "/v2/customers/projects/"

	}
}
export default API;